// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fileInput {
  margin: 0;
  padding: 2rem 1.5rem 3.5rem;
  font: 1rem/1.5 'PT Sans', Arial, sans-serif;
  color: #5a5a5a;
  cursor: pointer;
}
.test {
  border: none !important;
}
.custom_multiselect_settings{
  flex: 0 1 auto !important;
}
.custom-file-upload{
  border: 1px solid #ccc;
    display: inline-block;
    padding: 6px 12px;
    cursor: pointer;
}
.file_upload{
  display: none;
}

.fc-daygrid-day-top {
  justify-content: start !important;
  font-size: 12px;
  font-weight: 600;
}
.fc-daygrid-day-bottom {
  display: none !important;
}
.fc .fc-daygrid-day-frame {
  height: 117.4px !important;
  /* position: relative; */
}
.fc-daygrid-day-events {
  height: 87px !important;
}
.fc .fc-scroller-liquid-absolute{
  overflow: unset !important;
}
.scroller {
  overflow: hidden unset !important;
}
.rdt_TableRow {
  /* background-color: grey !important; */
}
.rdt_TableCol {
  color: black;
  font-weight: bolder;
}
.rdt_TableCol_Sortable {
}
.rdt_TableCell {
}
.rdt_TableHeader {
  background-color: transparent;
}
.rdt_TableFooter {
}
.rdt_TableHead {
}
.rdt_TableHeadRow {
  min-height: 34px !important;
  background-color: #f3f2f7 !important;
}
.rdt_TableBody {
}
.rdt_ExpanderRow {
}
.chakra-link {
}
.view_actions{
  justify-content: flex-end !important;
}
/* .active-class {
  color: black;
  width: 240px;
  background-image: linear-gradient(
    to right,
    var(--chakra-colors-blue-400),
    var(--chakra-colors-blue-500),
    var(--chakra-colors-blue-600)
  ) !important;
} */
.active-class .nav-active {
  color: var(--chakra-colors-white) !important;
  background-image: linear-gradient(
    to right,
    var(--chakra-colors-blue-400),
    var(--chakra-colors-blue-500),
    var(--chakra-colors-blue-600)
  );
}

.header-active-class {
  /* color: #253053 !important; */
  font-weight: 800;
  color: #ffffff;
  background-color: #2c82d1;
  padding: 10px;
  border-radius: 0.375rem;
}
.heading {
  width: 100%;
  font-style: normal;
  font-weight: 700;

  line-height: 95%;
  /* or 63px */
  color: #253053;
}
.sub-heading {
  font-style: normal;
  font-weight: 500;
  color: #253053;
}
.span-text {
  color: #253053;
}
.input-class {
  box-sizing: border-box;
  margin-bottom: 16px;
  background: #ffffff;
  border: 1px solid #cccccc;
  border-radius: 5px;
  padding-left: 9px;
  color: 'red';
}
.index-z {
  z-index: 1 !important;
}
.submit-button {
  background-color: #253053;
  color: #ffffff;
  border-radius: 4px;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 23px;
  text-align: center;
}

.testimonial-heading {
  font-style: normal;
  font-weight: 700;
  text-align: center;
  color: #253053;
}
.card {
  /* width: 329px; */
  height: 222px;
  background: #f4f9fd;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 20px;
}

.image-text {
  font-style: normal;
  font-weight: 700;
  text-align: center;
  color: #ffffff;
}
.trial-btn {
  width: 395px;
  height: 56px;
  background-color: #24d18e;
  color: #ffffff;
  font-style: normal;
  font-weight: 600;
  font-size: 30px;
  line-height: 35px;
  text-align: center;
  border-radius: 4px;
}
.txt-class {
  display: flex;
  flex-direction: column;
  font-style: normal;
  font-weight: 600;
  color: #253053;
}
.card-haeding {
  text-align: start;
  /* width: 194px; */
  /* height: 32px; */
  font-style: normal;
  font-weight: 800;
  /* font-size: 25px; */
  /* line-height: 130%; */
  /* or 32px */
  color: #031838;
}
.card-text {
  /* width: 271px; */
  height: 95px;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: #253053;
  text-align: start;
}
.image-txt {
  color: #ffffff;
  font-style: normal;
  font-weight: 700;
  text-align: center;
}
.sign-up-btn {
  margin-top: 10px;
  width: 309px;
  height: 56px;
  background: #253053;
  border-radius: 5px;
  font-style: normal;
  font-weight: 600;
  font-size: 30px;
  line-height: 35px;
  text-align: center;
  color: #ffffff;
}
.header-txt {
  font-weight: 500;
  font-size: 16px;
  line-height: 100.4%;
}

.header-txt:hover {
  color: #ffffff;
  background-color: #2c82d1;
  padding: 15px;
  border-radius: 0.375rem;
}
.bnAwAJ {
  cursor: default !important;
}

/* CROUSEL */
.carousel .slider-wrapper {
  width: 77vw !important;
  height: 222px;
}

/* Link Underline Removed */
.css-spn4bz:hover,
.css-spn4bz[data-hover] {
  -webkit-text-decoration: none;
  text-decoration: none !important;
}

.rsis-image {
  background-size: contain !important;
  background-repeat: no-repeat !important;
  background-color: white;
}

.screenshot-image {
  width: 105px;
  height: 200px;
}
.screenshot-image img {
  display: block;
  margin: 0 auto;
}
.overlay {
  display: block;
  position: absolute;
  top: 0px;
  left: 0px;
}


.screenshot-unorderlist .screenshot-list {
  display: flex;
  justify-content: center;
  align-items: center;
}
.screenshot-list:hover .overlay {
  display: block;
}
.bt1 {
  float: right !important;
  justify-content: right !important;
}


.input[type="file"]::before {
  content: "Upload CSV"; /* Change the button text */
  display: inline-block;
  background-color: #3182ce; /* Change the background color */
  color: #fff; /* Change the text color */
  padding: 2px 20px; /* Change the padding */
  border: 2px solid #3182ce; /* Change the border */
  border-radius: 5px; /* Change the border radius */
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  /* z-index: 10; */
}

/* Hide the original file .input button */
.input[type="file"] {
  /* opacity: 0; */
  /* position: absolute; */
  z-index: -1;
}

.flatpickr-input[type="text"]::placeholder {
    color: hsl(1, 0%, 50%);
    margin-left: 2px;
  }

.calendar-custom-button .fc-header-toolbar button {
    font-size: small !important;
    justify-content: flex-end !important;
    background: linear-gradient(to right, #1e40af, #3b82f6, #60a5fa) !important;
    color: white !important;
}

.custom-flatpickr-calander {
  width: 100px; /* Set the desired width */
}

/* .fc-customButton-button{
  margin-left: 50% !important
} */
.fc-daygrid-day {
  cursor: pointer;
}
.popup {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #ffffff;
  padding: 10px;
  /* Add additional styles as needed */
}
.icon-size {
  font-size: 14px;
}
.icon-mouse {
 transform: rotate(-90deg);
}
.icon-keyboard {
  margin-top: -3px;
}
.text-size {
  font-size: 9px;
  min-width: 30px;
}
.flatpickr-calendar {
  right: 6px !important;
}
.calender-outer .fc .fc-button-primary {
  position: absolute;
  right: 50px;
  background-color: #2D77BF;
  border: none;
}
.calender-outer .fc .fc-button-primary:hover,
.calender-outer .fc .fc-button-primary:focus {
  background-color: #296aab;
  border: none;
}
.calender-outer .fc .fc-toolbar-title{
  position: relative;
  top: 13px;
}
.modal-width {
  max-width: 800px !important;
}
#dataTable div[role="columnheader"] > span {
  display: none;
}
.data_text {
  text-transform: lowercase;
}
.data_text::first-letter {
  text-transform: capitalize;
}
div[role="heading"] {
  padding: 0;
  font-size: 1.25rem;
}
.menu-dropdown > div {
  z-index: 2 !important;
}
.label-handle{
  margin-top: 0px !important;
  margin-bottom: 2px !important;
}
.custom-datepicker-input{
  font-size: 18px;
  font-weight: 700;
}
.label-handle-bottom{
  margin-bottom: 0 !important;
}
.label-gap{
  gap: 1px !important;
}
#text::placeholder {
  color: #7F899C;
  font-weight: 500;
  font-size: 14px;
}
input {
  border-radius: 5px !important;
  border-color: #f1f1f1 !important;
}
.drawer-main .chakra-stack {
  gap: 15px !important;
}
.mgTop {
  margin-top: -6px !important;
}
.flatpickr-months,
.flatpickr-weekdays {
  background-color: #42a5f5 !important;
}
#imageSlider button {
  background-color: #3183CE !important;
  border-radius: 100%;
  height: 35px;
  width: 35px !important;
  display: flex;
  justify-content: center;
  align-items: center;
}
#imageSlider button img {
  height: 22px;
  width: 33px;
}
#imageSlider .rsis-container .rsis-image {
  background-size: contain !important;
  background-repeat: no-repeat !important;
  background-position: center center !important;
}
#imageSlider .rsis-container div + div {
  background-size: contain !important;
  background-repeat: no-repeat !important;
  background-position: center center !important;
}
.flatpickr-input::placeholder {
  font-size: 14px;
  font-weight: 500;
}
.chakra-modal__close-btn {
  margin-right: 10px !important;
}
.menue-list-item-week{
  min-width: 111px !important;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/global.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,2BAA2B;EAC3B,2CAA2C;EAC3C,cAAc;EACd,eAAe;AACjB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,yBAAuB;AACzB;AACA;EACE,sBAAsB;IACpB,qBAAqB;IACrB,iBAAiB;IACjB,eAAe;AACnB;AACA;EACE,aAAa;AACf;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,0BAA0B;EAC1B,wBAAwB;AAC1B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,iCAAiC;AACnC;AACA;EACE,uCAAuC;AACzC;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;AACA;AACA;AACA;AACA;EACE,6BAA6B;AAC/B;AACA;AACA;AACA;AACA;AACA;EACE,2BAA2B;EAC3B,oCAAoC;AACtC;AACA;AACA;AACA;AACA;AACA;AACA;AACA;EACE,oCAAoC;AACtC;AACA;;;;;;;;;GASG;AACH;EACE,4CAA4C;EAC5C;;;;;GAKC;AACH;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;;EAEhB,gBAAgB;EAChB,YAAY;EACZ,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,qBAAqB;AACvB;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;EACvB,YAAY;EACZ,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,0BAA0B;AAC5B;;AAEA,YAAY;AACZ;EACE,sBAAsB;EACtB,aAAa;AACf;;AAEA,2BAA2B;AAC3B;;EAEE,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,mCAAmC;EACnC,uCAAuC;EACvC,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;AACA;EACE,cAAc;EACd,cAAc;AAChB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,SAAS;AACX;;;AAGA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,uBAAuB;EACvB,iCAAiC;AACnC;;;AAGA;EACE,qBAAqB,EAAE,2BAA2B;EAClD,qBAAqB;EACrB,yBAAyB,EAAE,gCAAgC;EAC3D,WAAW,EAAE,0BAA0B;EACvC,iBAAiB,EAAE,uBAAuB;EAC1C,yBAAyB,EAAE,sBAAsB;EACjD,kBAAkB,EAAE,6BAA6B;EACjD,eAAe;EACf,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA,yCAAyC;AACzC;EACE,gBAAgB;EAChB,wBAAwB;EACxB,WAAW;AACb;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;EAClB;;AAEF;IACI,2BAA2B;IAC3B,oCAAoC;IACpC,2EAA2E;IAC3E,uBAAuB;AAC3B;;AAEA;EACE,YAAY,EAAE,0BAA0B;AAC1C;;AAEA;;GAEG;AACH;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,yBAAyB;EACzB,aAAa;EACb,oCAAoC;AACtC;AACA;EACE,eAAe;AACjB;AACA;CACC,yBAAyB;AAC1B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,YAAY;AACd;AACA;;EAEE,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,aAAa;AACf;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,6BAA6B;EAC7B,gCAAgC;AAClC;AACA;EACE,oBAAoB;AACtB;AACA;EACE,2BAA2B;AAC7B;AACA;;EAEE,oCAAoC;AACtC;AACA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,mCAAmC;EACnC,uCAAuC;EACvC,6CAA6C;AAC/C;AACA;EACE,mCAAmC;EACnC,uCAAuC;EACvC,6CAA6C;AAC/C;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,2BAA2B;AAC7B","sourcesContent":[".fileInput {\n  margin: 0;\n  padding: 2rem 1.5rem 3.5rem;\n  font: 1rem/1.5 'PT Sans', Arial, sans-serif;\n  color: #5a5a5a;\n  cursor: pointer;\n}\n.test {\n  border: none !important;\n}\n.custom_multiselect_settings{\n  flex: 0 auto !important;\n}\n.custom-file-upload{\n  border: 1px solid #ccc;\n    display: inline-block;\n    padding: 6px 12px;\n    cursor: pointer;\n}\n.file_upload{\n  display: none;\n}\n\n.fc-daygrid-day-top {\n  justify-content: start !important;\n  font-size: 12px;\n  font-weight: 600;\n}\n.fc-daygrid-day-bottom {\n  display: none !important;\n}\n.fc .fc-daygrid-day-frame {\n  height: 117.4px !important;\n  /* position: relative; */\n}\n.fc-daygrid-day-events {\n  height: 87px !important;\n}\n.fc .fc-scroller-liquid-absolute{\n  overflow: unset !important;\n}\n.scroller {\n  overflow: hidden unset !important;\n}\n.rdt_TableRow {\n  /* background-color: grey !important; */\n}\n.rdt_TableCol {\n  color: black;\n  font-weight: bolder;\n}\n.rdt_TableCol_Sortable {\n}\n.rdt_TableCell {\n}\n.rdt_TableHeader {\n  background-color: transparent;\n}\n.rdt_TableFooter {\n}\n.rdt_TableHead {\n}\n.rdt_TableHeadRow {\n  min-height: 34px !important;\n  background-color: #f3f2f7 !important;\n}\n.rdt_TableBody {\n}\n.rdt_ExpanderRow {\n}\n.chakra-link {\n}\n.view_actions{\n  justify-content: flex-end !important;\n}\n/* .active-class {\n  color: black;\n  width: 240px;\n  background-image: linear-gradient(\n    to right,\n    var(--chakra-colors-blue-400),\n    var(--chakra-colors-blue-500),\n    var(--chakra-colors-blue-600)\n  ) !important;\n} */\n.active-class .nav-active {\n  color: var(--chakra-colors-white) !important;\n  background-image: linear-gradient(\n    to right,\n    var(--chakra-colors-blue-400),\n    var(--chakra-colors-blue-500),\n    var(--chakra-colors-blue-600)\n  );\n}\n\n.header-active-class {\n  /* color: #253053 !important; */\n  font-weight: 800;\n  color: #ffffff;\n  background-color: #2c82d1;\n  padding: 10px;\n  border-radius: 0.375rem;\n}\n.heading {\n  width: 100%;\n  font-style: normal;\n  font-weight: 700;\n\n  line-height: 95%;\n  /* or 63px */\n  color: #253053;\n}\n.sub-heading {\n  font-style: normal;\n  font-weight: 500;\n  color: #253053;\n}\n.span-text {\n  color: #253053;\n}\n.input-class {\n  box-sizing: border-box;\n  margin-bottom: 16px;\n  background: #ffffff;\n  border: 1px solid #cccccc;\n  border-radius: 5px;\n  padding-left: 9px;\n  color: 'red';\n}\n.index-z {\n  z-index: 1 !important;\n}\n.submit-button {\n  background-color: #253053;\n  color: #ffffff;\n  border-radius: 4px;\n  font-style: normal;\n  font-weight: 500;\n  font-size: 20px;\n  line-height: 23px;\n  text-align: center;\n}\n\n.testimonial-heading {\n  font-style: normal;\n  font-weight: 700;\n  text-align: center;\n  color: #253053;\n}\n.card {\n  /* width: 329px; */\n  height: 222px;\n  background: #f4f9fd;\n  border-radius: 5px;\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  padding: 20px;\n}\n\n.image-text {\n  font-style: normal;\n  font-weight: 700;\n  text-align: center;\n  color: #ffffff;\n}\n.trial-btn {\n  width: 395px;\n  height: 56px;\n  background-color: #24d18e;\n  color: #ffffff;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 30px;\n  line-height: 35px;\n  text-align: center;\n  border-radius: 4px;\n}\n.txt-class {\n  display: flex;\n  flex-direction: column;\n  font-style: normal;\n  font-weight: 600;\n  color: #253053;\n}\n.card-haeding {\n  text-align: start;\n  /* width: 194px; */\n  /* height: 32px; */\n  font-style: normal;\n  font-weight: 800;\n  /* font-size: 25px; */\n  /* line-height: 130%; */\n  /* or 32px */\n  color: #031838;\n}\n.card-text {\n  /* width: 271px; */\n  height: 95px;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 19px;\n  color: #253053;\n  text-align: start;\n}\n.image-txt {\n  color: #ffffff;\n  font-style: normal;\n  font-weight: 700;\n  text-align: center;\n}\n.sign-up-btn {\n  margin-top: 10px;\n  width: 309px;\n  height: 56px;\n  background: #253053;\n  border-radius: 5px;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 30px;\n  line-height: 35px;\n  text-align: center;\n  color: #ffffff;\n}\n.header-txt {\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 100.4%;\n}\n\n.header-txt:hover {\n  color: #ffffff;\n  background-color: #2c82d1;\n  padding: 15px;\n  border-radius: 0.375rem;\n}\n.bnAwAJ {\n  cursor: default !important;\n}\n\n/* CROUSEL */\n.carousel .slider-wrapper {\n  width: 77vw !important;\n  height: 222px;\n}\n\n/* Link Underline Removed */\n.css-spn4bz:hover,\n.css-spn4bz[data-hover] {\n  -webkit-text-decoration: none;\n  text-decoration: none !important;\n}\n\n.rsis-image {\n  background-size: contain !important;\n  background-repeat: no-repeat !important;\n  background-color: white;\n}\n\n.screenshot-image {\n  width: 105px;\n  height: 200px;\n}\n.screenshot-image img {\n  display: block;\n  margin: 0 auto;\n}\n.overlay {\n  display: block;\n  position: absolute;\n  top: 0px;\n  left: 0px;\n}\n\n\n.screenshot-unorderlist .screenshot-list {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.screenshot-list:hover .overlay {\n  display: block;\n}\n.bt1 {\n  float: right !important;\n  justify-content: right !important;\n}\n\n\n.input[type=\"file\"]::before {\n  content: \"Upload CSV\"; /* Change the button text */\n  display: inline-block;\n  background-color: #3182ce; /* Change the background color */\n  color: #fff; /* Change the text color */\n  padding: 2px 20px; /* Change the padding */\n  border: 2px solid #3182ce; /* Change the border */\n  border-radius: 5px; /* Change the border radius */\n  cursor: pointer;\n  transition: all 0.3s ease-in-out;\n  /* z-index: 10; */\n}\n\n/* Hide the original file .input button */\n.input[type=\"file\"] {\n  /* opacity: 0; */\n  /* position: absolute; */\n  z-index: -1;\n}\n\n.flatpickr-input[type=\"text\"]::placeholder {\n    color: hsl(1, 0%, 50%);\n    margin-left: 2px;\n  }\n\n.calendar-custom-button .fc-header-toolbar button {\n    font-size: small !important;\n    justify-content: flex-end !important;\n    background: linear-gradient(to right, #1e40af, #3b82f6, #60a5fa) !important;\n    color: white !important;\n}\n\n.custom-flatpickr-calander {\n  width: 100px; /* Set the desired width */\n}\n\n/* .fc-customButton-button{\n  margin-left: 50% !important\n} */\n.fc-daygrid-day {\n  cursor: pointer;\n}\n.popup {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background-color: #ffffff;\n  padding: 10px;\n  /* Add additional styles as needed */\n}\n.icon-size {\n  font-size: 14px;\n}\n.icon-mouse {\n transform: rotate(-90deg);\n}\n.icon-keyboard {\n  margin-top: -3px;\n}\n.text-size {\n  font-size: 9px;\n  min-width: 30px;\n}\n.flatpickr-calendar {\n  right: 6px !important;\n}\n.calender-outer .fc .fc-button-primary {\n  position: absolute;\n  right: 50px;\n  background-color: #2D77BF;\n  border: none;\n}\n.calender-outer .fc .fc-button-primary:hover,\n.calender-outer .fc .fc-button-primary:focus {\n  background-color: #296aab;\n  border: none;\n}\n.calender-outer .fc .fc-toolbar-title{\n  position: relative;\n  top: 13px;\n}\n.modal-width {\n  max-width: 800px !important;\n}\n#dataTable div[role=\"columnheader\"] > span {\n  display: none;\n}\n.data_text {\n  text-transform: lowercase;\n}\n.data_text::first-letter {\n  text-transform: capitalize;\n}\ndiv[role=\"heading\"] {\n  padding: 0;\n  font-size: 1.25rem;\n}\n.menu-dropdown > div {\n  z-index: 2 !important;\n}\n.label-handle{\n  margin-top: 0px !important;\n  margin-bottom: 2px !important;\n}\n.custom-datepicker-input{\n  font-size: 18px;\n  font-weight: 700;\n}\n.label-handle-bottom{\n  margin-bottom: 0 !important;\n}\n.label-gap{\n  gap: 1px !important;\n}\n#text::placeholder {\n  color: #7F899C;\n  font-weight: 500;\n  font-size: 14px;\n}\ninput {\n  border-radius: 5px !important;\n  border-color: #f1f1f1 !important;\n}\n.drawer-main .chakra-stack {\n  gap: 15px !important;\n}\n.mgTop {\n  margin-top: -6px !important;\n}\n.flatpickr-months,\n.flatpickr-weekdays {\n  background-color: #42a5f5 !important;\n}\n#imageSlider button {\n  background-color: #3183CE !important;\n  border-radius: 100%;\n  height: 35px;\n  width: 35px !important;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n#imageSlider button img {\n  height: 22px;\n  width: 33px;\n}\n#imageSlider .rsis-container .rsis-image {\n  background-size: contain !important;\n  background-repeat: no-repeat !important;\n  background-position: center center !important;\n}\n#imageSlider .rsis-container div + div {\n  background-size: contain !important;\n  background-repeat: no-repeat !important;\n  background-position: center center !important;\n}\n.flatpickr-input::placeholder {\n  font-size: 14px;\n  font-weight: 500;\n}\n.chakra-modal__close-btn {\n  margin-right: 10px !important;\n}\n.menue-list-item-week{\n  min-width: 111px !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
